import { toLower } from 'lodash';
import styles from './AppPayoutTime.module.scss';
import { useTranslation } from 'next-i18next';
import { Col, Row } from 'antd';

const AppPayoutTime = ({ routerPath, content }: any) => {
    return (
        <div className={`${styles.container}`}>
            <div
                className={styles.notice}
                dangerouslySetInnerHTML={{ __html: content?.NoticeMessage?.value }}
            ></div>
            <Row className={styles['tournament-info']}>
                {content.tournamentInfo.targetItems.map((t: any, n: number) => {
                    return t?.tournamentName?.value ? (
                        <Col sm={12} md={6} key={t?.tournamentCode?.value || n}>
                            {t?.tournamentIcon?.src && (
                                <img src={t?.tournamentIcon?.src} alt={t?.tournamentName?.value} />
                            )}
                            {t?.tournamentName?.value}
                        </Col>
                    ) : (
                        ''
                    );
                })}
            </Row>
            <div
                className={styles.remarks}
                dangerouslySetInnerHTML={{ __html: content?.Remarks?.value }}
            ></div>
        </div>
    );
};

export default AppPayoutTime;
